// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remark-wrapper textarea[data-v-1bb4051f] {\n  overflow-y: auto;\n  max-height: 180px;\n}\n", ""]);
// Exports
module.exports = exports;
